// extracted by mini-css-extract-plugin
module.exports = {"HeroControls":"az_src","Counter":"az_trc","PauseButton":"az_urc","Light":"az_vrc","Dark":"az_wrc"};